export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer-copy">© {new Date().getFullYear()} saket_kumar — v2.0</p>
      <p className="footer-city">[blr/in] — built w/ react</p>
    </footer>
  );
}
